import React from 'react'
import { SearchNormal1 } from 'iconsax-react'
import { useTheme } from '@mui/material'

import useStyles from './styles'

const Search = ({
  onSearch,
  fullWidth,
  children = undefined,
  searchVal = ''
}) => {
  const theme = useTheme()

  const [search, setSearch] = React.useState(searchVal)

  const classes = useStyles({ fullWidth })

  const handleSearch = React.useCallback(
    e => {
      const val = e.target.value
      setSearch(val)
      onSearch(val)
    },
    [onSearch]
  )

  React.useEffect(() => {
    setSearch(searchVal)
  }, [searchVal])

  return (
    <div className={classes.root}>
      <label htmlFor='search' className={classes.icon}>
        <SearchNormal1 variant='Outline' size={theme.size.base} />
      </label>

      {children && <div className={classes.children}>{children}</div>}

      <input
        id='search'
        value={search}
        onChange={handleSearch}
        placeholder='Search...'
        className={classes.input}
        maxLength={20}
        autoComplete='off'
      />
    </div>
  )
}

export default Search
